import React from 'react';
import { cssMap } from '@atlaskit/css';
import { Inline, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';

const styles = cssMap({
	container: {
		height: '480px',
		width: '600px',
		paddingBlock: token('space.250'),
		paddingInline: token('space.250'),
	},
	headerPadding: {
		paddingBottom: token('space.600'),
	},
	footerPadding: {
		paddingTop: token('space.1000'),
	},
});

export const FallbackSkeleton = () => {
	return (
		<UFOLoadHold name="filter-popup-fallback">
			<Stack xcss={styles.container}>
				<Inline spread="space-between" xcss={styles.headerPadding}>
					<Skeleton isShimmering width="200px" height="32px" />
					<Skeleton isShimmering width="141px" height="32px" />
				</Inline>
				<Stack space="space.400">
					{Array.from({ length: 5 }, (_, index) => (
						<Skeleton isShimmering key={index} width="552px" height="24px" />
					))}
				</Stack>
				<Inline spread="space-between" xcss={styles.footerPadding}>
					<Skeleton isShimmering width="124px" height="24px" />
					<Skeleton isShimmering width="249px" height="24px" />
				</Inline>
			</Stack>
		</UFOLoadHold>
	);
};
